const DEGREE_SIGN = '°'; // String.fromCodePoint(176)
const MINUTE_SIGN = String.fromCodePoint(8242);
const SECOND_SIGN = String.fromCodePoint(8243);

function decimal2Sexagesimal(decimal?: number, precision=4) {
  if (decimal == null) {
    return null;
  }

  const degrees = Math.trunc(decimal);

  const rest = (decimal - degrees) * 60;
  const minutes = Math.trunc(rest);
  const seconds = (rest - minutes) * 60;

  return `${degrees}${DEGREE_SIGN} ${minutes}${MINUTE_SIGN} ${seconds.toFixed(precision)}${SECOND_SIGN}`;
}

export default decimal2Sexagesimal;
